export const GameLoadingDuration = 3;
export const OtherLoadingDuration = 1;
